import { Blocks } from "react-loader-spinner";

const Loading = () => (
	<div className="flex justify-center w-full">
		<Blocks
			height="80"
			width="80"
			color="green"
			ariaLabel="blocks-loading"
			wrapperStyle={{}}
			wrapperClass="blocks-wrapper"
			visible={true}
		/>
	</div>
);

export default Loading;
